module.exports = __webpack_public_path__ + "static/media/special-stone.5894a8bb.svg";